<template>
    <div>
        <p class="has-text-weight-bold mb-2">{{ translateRule(ruleData.rule) }}</p>
        <div>
            <span class="icon">
                <i class="fas fa-chart-bar"></i>
            </span>
            <span>
                {{ translate("page.admin_academy_results.points_awarded_for_each_match_won") }}
                {{ ruleData.input.pointsForWonMatch }}
            </span>
        </div>
        <div>
            <span class="icon">
                <i class="has-text-success fa fa-check-circle" v-if="ruleData.input.multiplierForSubmissionWin !== null" />
                <i class="has-text-danger fa fa-times-circle" v-else />
            </span>
            <span>
                {{ translate("event_ranking.rule.promoteSubmission") }}
                <template v-if="ruleData.input.multiplierForSubmissionWin"> ({{ ruleData.input.multiplierForSubmissionWin }}x) </template>
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { translateRule } from "../addRuleStore";
    import { ScoreForWonMatchesRule } from "../../../Api/competitorResultsApi";
    import { translate } from "../../../Common/translations";

    defineProps<{
        ruleData: ScoreForWonMatchesRule;
    }>();
</script>

<style scoped></style>
